const ADDRESS_VERIFICATION_DOCUMENT_TYPES = {
  ELECTRICITY_BILL: {
    value: "electricity_bill",
    readableName: "Electricity Bill",
  },
  NATURAL_GAS_BILL: {
    value: "natural_gas_bill",
    readableName: "Natural Gas Bill",
  },
  BANK_STATEMENT: {
    value: "bank_statement",
    readableName: "Bank Statement",
  },
  OTHER: {
    value: "other",
    readableName: "Other",
  },
};

// Convert the object to an array of entries
export const addressVerificationDocumentTypesArray = Object.values(
  ADDRESS_VERIFICATION_DOCUMENT_TYPES,
);
